// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/promotional-banner/promotional-banner.component.scss
// module id = 469
// module chunks = 0